import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinhadapsarpune() {



const cardData =
{
  keyword: 'Cab Service in Hadapsar Pune',
  heading: 'Sanavi Travels: Cab Service in Hadapsar Pune',
  headingDescription: 'Sanavi Travels provides premium, reliable, and professionally managed cab service in Hadapsar Pune, catering to the high travel demand of IT professionals, corporate employees, business executives, families, and daily commuters. Hadapsar is one of Pune’s fastest-growing commercial and residential zones, surrounded by Magarpatta City, SP Infocity, Amanora Park Town, industrial belts, shopping hubs, and major highways, making dependable cab transportation essential. Our cab service in Hadapsar Pune is ideal for daily office commute, corporate travel, employee pickup and drop, airport transfers, railway station pickups, local city travel, and long-distance outstation journeys. We operate a wide fleet of AC and Non-AC sedans and SUVs that are regularly serviced, thoroughly cleaned, and designed for comfort even during peak traffic hours. Our trained and background-verified drivers have deep knowledge of Hadapsar routes, IT park schedules, office timings, and Pune city traffic patterns, ensuring punctual pickups and smooth journeys. With transparent pricing, flexible booking options, route customization, and responsive customer support, Sanavi Travels delivers a stress-free, comfortable, and time-efficient cab travel experience in Hadapsar Pune for both individuals and corporate clients.',

  top: 'Top Travel Needs & Connectivity in Hadapsar Pune with Sanavi Travels',

  "topPlaces": [
    {
      "title": "Daily Office Commute in Hadapsar",
      "description": "Cab service in Hadapsar Pune plays a crucial role in daily office commute for employees working in Magarpatta City, SP Infocity, Amanora, and nearby IT corridors. Reliable cab transportation ensures punctual arrival, reduces dependency on crowded public transport, and provides safe return travel during late working hours. Organized cab services improve productivity, reduce daily commute fatigue, and enhance work-life balance for professionals."
    },
    {
      "title": "Magarpatta City & IT Park Connectivity",
      "description": "Hadapsar is closely connected to major IT parks and corporate hubs. Cab services ensure seamless movement of employees, managers, consultants, and corporate guests between offices, meetings, hotels, and residential zones, maintaining efficiency and professional standards."
    },
    {
      "title": "Airport Transfers from Hadapsar",
      "description": "Frequent business travelers and families rely on cab services in Hadapsar for airport pickups and drops. Timely scheduling, experienced drivers, comfortable seating, and sufficient luggage space ensure stress-free airport connectivity aligned with flight schedules."
    },
    {
      "title": "Railway Station Pickup & Drop",
      "description": "Cab services provide dependable railway station transfers from Hadapsar, ensuring smooth connectivity for employees, families, and visiting professionals without delays or confusion."
    },
    {
      "title": "Corporate Meetings & Business Travel",
      "description": "Executives attending meetings, conferences, and client visits within Pune depend on professional cab services for punctual, comfortable, and hassle-free business travel."
    },
    {
      "title": "Employee Transportation Services",
      "description": "Cab services in Hadapsar support structured employee transportation, including shift-based travel, daily office commute, and late-night pickups, ensuring safety and reliability."
    },
    {
      "title": "Corporate Events & Conferences",
      "description": "Cab services manage transportation for seminars, conferences, exhibitions, and corporate events held in and around Hadapsar with coordinated scheduling and disciplined execution."
    },
    {
      "title": "Team Outings & Office Picnics",
      "description": "For office picnics and team outings, cab services provide safe, comfortable, and organized group travel, allowing teams to focus on engagement rather than logistics."
    },
    {
      "title": "Residential Area Connectivity",
      "description": "Hadapsar’s large residential population relies on cab services for daily travel, shopping, medical visits, and family outings, ensuring dependable citywide connectivity."
    },
    {
      "title": "Local & Outstation Travel",
      "description": "From short city trips to long outstation journeys, cab services in Hadapsar offer flexible routes, customized schedules, and comfortable vehicles for every travel need."
    }
  ],

  "services": [
    {
      "name": "Cab Service in Hadapsar Pune",
      "description": "Sanavi Travels offers a complete cab service in Hadapsar Pune designed for daily commuters, corporate clients, and families. This service supports office commute, employee transport, airport and railway transfers, local city travel, and long-distance outstation journeys. With AC and Non-AC sedans and SUVs, trained drivers, route planning, and punctual service, it ensures safe, comfortable, and efficient travel. The service helps reduce travel stress, saves time, and improves daily mobility across Hadapsar and Pune."
    },
    {
      "name": "AC Cab Hire Hadapsar",
      "description": "AC cab hire in Hadapsar provides a cool, comfortable, and relaxing travel experience, especially suitable for long commutes, business travel, summer journeys, and airport transfers."
    },
    {
      "name": "Non AC Cab Hadapsar",
      "description": "Non AC cab service in Hadapsar is a budget-friendly travel option for short distances and regular commute, offering safe and reliable transportation at economical rates."
    },
    {
      "name": "Sedan Cab Service Hadapsar",
      "description": "Sedan cab service in Hadapsar is ideal for individuals, executives, and small families, offering fuel efficiency, comfort, smooth rides, and professional appearance for business travel."
    },
    {
      "name": "SUV Cab Service Hadapsar",
      "description": "SUV cab service in Hadapsar supports group travel, luggage-heavy trips, and family outings with spacious seating, stability, and enhanced ride comfort."
    },
    {
      "name": "Cab for Office Commute Hadapsar",
      "description": "Office commute cabs in Hadapsar ensure punctual daily pickups, safe drop-offs, and optimized routes for employees working in IT parks and corporate offices."
    },
    {
      "name": "Cab for Corporate Travel Hadapsar",
      "description": "Corporate cab service in Hadapsar supports meetings, conferences, client visits, and executive travel with disciplined drivers and professional service standards."
    },
    {
      "name": "Affordable Cab Service Hadapsar",
      "description": "Affordable cab service in Hadapsar offers transparent pricing and flexible packages, helping individuals and businesses manage transportation budgets efficiently."
    },
    {
      "name": "Best Cab Service Hadapsar",
      "description": "Best cab service in Hadapsar by Sanavi Travels is trusted for safety, punctuality, comfort, and consistent service quality."
    },
    {
      "name": "Cab with Driver Hadapsar",
      "description": "All cabs include experienced, background-verified drivers familiar with Hadapsar routes, traffic patterns, and corporate travel etiquette."
    },
    {
      "name": "Cab for Airport Transfer Hadapsar",
      "description": "Airport transfer cabs from Hadapsar ensure timely arrivals, smooth coordination with flight schedules, and comfortable luggage handling."
    },
    {
      "name": "Cab for Railway Pickup Hadapsar",
      "description": "Railway pickup cabs in Hadapsar offer reliable station transfers with punctual service and stress-free travel."
    },
    {
      "name": "Cab for Employees Hadapsar",
      "description": "Employee cab services in Hadapsar support daily commute and shift-based transport with safety, punctuality, and route optimization."
    },
    {
      "name": "Cab for Corporate Events Hadapsar",
      "description": "Corporate event cabs in Hadapsar manage transportation for seminars, meetings, exhibitions, and official gatherings."
    },
    {
      "name": "Cab for Team Outing Hadapsar",
      "description": "Team outing cab services in Hadapsar provide organized, comfortable, and safe group travel for office picnics and outings."
    }
  ],

  "tableData": [
    ["Cab Service Hadapsar Pune", "Office Commute Cabs"],
    ["AC Cabs", "Non AC Cabs"],
    ["Sedan Cabs", "SUV Cabs"],
    ["Airport Transfer Cabs", "Railway Pickup Cabs"],
    ["Employee Transport", "Corporate Event Cabs"]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Local Expertise in Hadapsar",
      "WhyChoosedescription": "Deep understanding of Hadapsar traffic and commuting patterns ensures efficient travel."
    },
    {
      "WhyChooseheading": "Safe & Verified Drivers",
      "WhyChoosedescription": "All drivers are trained, background-verified, and professional."
    },
    {
      "WhyChooseheading": "Punctual Service",
      "WhyChoosedescription": "On-time pickups and drops support busy schedules."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Custom routes, timings, and packages available."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear billing with no hidden charges."
    },
    {
      "WhyChooseheading": "Comfortable Fleet",
      "WhyChoosedescription": "AC and Non-AC sedans and SUVs ensure smooth rides."
    },
    {
      "WhyChooseheading": "24/7 Support",
      "WhyChoosedescription": "Responsive coordination for bookings and assistance."
    },
    {
      "WhyChooseheading": "Trusted Cab Partner",
      "WhyChoosedescription": "Sanavi Travels is a reliable name for cab services in Hadapsar Pune."
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide cab service in Hadapsar Pune?',
    answer: 'Yes, Sanavi Travels provides reliable cab services throughout Hadapsar Pune.'
  },
  {
    question: 'Are AC and Non AC cabs available?',
    answer: 'Yes, both AC and Non AC cab options are available.'
  },
  {
    question: 'Can I book cabs for daily office commute?',
    answer: 'Yes, we offer scheduled cab services for daily office travel.'
  },
  {
    question: 'Do you provide airport and railway transfers?',
    answer: 'Yes, airport and railway station transfers are available.'
  },
  {
    question: 'Is driver included in the cab service?',
    answer: 'Yes, every cab includes a trained and verified driver.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'Excellent cab service in Hadapsar for daily office travel. Always punctual.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Patil',
    feedback: 'Very comfortable and professional cab service for corporate travel.',
    rating: 5
  }
];

































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service in Hadapsar Pune - Sanavi Travels",
  "description": "Sanavi Travels offers cab services in Hadapsar Pune for office commute, corporate travel, airport and railway pickups, employee transport, team outings, and corporate events. AC and Non-AC sedans and SUVs are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | Cab Service in Hadapsar Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book cab service in Hadapsar Pune with Sanavi Travels. AC & Non-AC sedans and SUVs for office commute, corporate travel, airport, railway, employee transport, team outings, and corporate events with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/264.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinhadapsarpune;